<template>
  <v-row>
    <v-col cols="12">
      <MyQuestionnairesTable
        :my-questionnaires="questionnaires"
        @view-questionnaire-status="viewQuestionnaireStatus"
      />
    </v-col>
  </v-row>
  <!-- Customer View -->
  <div class="text-right">
    <p class="text-center" v-if="!hasQuestionnaires">
      You do not have any available questionnaires...
    </p>
    <PPrimaryButton
      class="mt-5"
      id="my-questionnaires-view__create-new-btn"
      appkit-icon="icon-plus-fill"
      @click="$router.push(RouterPath.CreateQuestionnaire)"
      >Create new</PPrimaryButton
    >
  </div>
</template>

<script setup lang="ts">
import { RouterPath } from "@/models/enum/routerPath";
import type { Questionnaire } from "@/models/questionnaire";
import { useQuestionnairesStore } from "@/stores/questionnaires";
import { computed, ref } from "vue";
import { useRouter } from "vue-router";
import PPrimaryButton from "@/components/custom/buttons/PPrimaryButton.vue";
import MyQuestionnairesTable from "@/views/questionnaires/my-questionnaires/MyQuestionnairesTable.vue";
import { useSenderStore } from "@/stores/sender";

const props = defineProps<{
  questionnaires: Array<Questionnaire>;
}>();

const router = useRouter();
const questionnairesStore = useQuestionnairesStore();
const senderStore = useSenderStore();
const questionnaires = ref(props.questionnaires);
const hasQuestionnaires = computed(
  () => questionnaires.value && questionnaires.value.length > 0
);

const viewQuestionnaireStatus = (questionnaire: Questionnaire) =>
  setAndRoute(RouterPath.MyQuestionnaireStatus, questionnaire);

function setAndRoute(route: RouterPath, questionnaire: Questionnaire): void {
  senderStore.setOwnerParams(questionnaire);
  questionnairesStore.selectedQuestionnaire = questionnaire;
  router.push(route);
}
</script>
